export function formattedTemplateDataForEdit(templateData, organisation) {
  let templateDataClone = { ...templateData };
  const templateTags = {
    candidate_firstname: 'Lukman',
    candidate_middlename: 'Yusuf',
    candidate_lastname: 'Ekundayo',
    candidate_email: 'lukuluku@gmail.com',
    candidate_phonenumber: '08064513510',
    application_number: 'DSC-2021 RG-001',
    application_title: 'Application Into Dynamic Systems And Control',
    award_letter:
      'https://safapply-images.s3.amazonaws.com/safapply/candidate/letter/84522d17-7dc4-4776-9a6c-c92000e0cbba',
    course_title: 'DYNAMIC SYSTEMS AND CONTOL',
    course_code: 'DSC 201',
    course_duration: '4',
    course_duration_unit: 'Years',
    course_admin_level_item_parent_name: 'Natural and Applied Sciences',
    course_admin_level_item_name: 'Computer Science',
    institution_name: organisation?.name,
    institution_address: organisation?.address,
    institution_logo: `${organisation.logoUrl}?b=${Date.now()}`,
    institution_id: organisation?.id,
    candidate_id: '03d584b1-2582-4acc-b16e-992a3527f1c9',
    location_name: 'Abuja Nigeria Law School',
    location_address:
      'Area Council, Bwari, Abuja, FCT, 101 Law School Rd, 901101, Bwari',
    state_of_origin: 'Lagos State',
    lga: 'Ikeja',
  };
  const metaData = {
    logo: {
      value: `${organisation.logoUrl}?b=${Date.now()}` || '',
      label: 'Logo',
      editable: true,
    },
    brandName: {
      value: '',
      label: 'Brand Name',
      editable: true,
    },
    address: {
      value: organisation?.address || '',
      label: 'Address',
      editable: true,
    },
    title: {
      value: templateDataClone?.name || '',
      label: 'Message Title',
      editable: false,
    },
  };
  templateDataClone = {
    ...templateData,
    keys: templateTags,
    metadata: metaData,
  };
  return templateDataClone;
}

export function formattedTemplateDataForcreation(templateData, organisation) {
  let templateDataClone = { ...templateData };
  const templateTags = {
    candidate_firstname: 'Lukman',
    candidate_middlename: 'Yusuf',
    candidate_lastname: 'Ekundayo',
    candidate_email: 'lukuluku@gmail.com',
    candidate_phonenumber: '08064513510',
    application_number: 'DSC-2021 RG-001',
    application_title: 'Application Into Dynamic Systems And Control',
    award_letter:
      'https://safapply-images.s3.amazonaws.com/safapply/candidate/letter/84522d17-7dc4-4776-9a6c-c92000e0cbba',
    course_title: 'DYNAMIC SYSTEMS AND CONTOL',
    course_code: 'DSC 201',
    course_duration: '4',
    course_duration_unit: 'Years',
    course_admin_level_item_parent_name: 'Natural and Applied Sciences',
    course_admin_level_item_name: 'Computer Science',
    institution_name: organisation?.name,
    institution_address: organisation?.address,
    institution_logo: `${organisation.logoUrl}?b=${Date.now()}`,
    institution_id: organisation?.id,
    candidate_id: '03d584b1-2582-4acc-b16e-992a3527f1c9',
    location_name: 'Abuja Nigeria Law School',
    location_address:
      'Area Council, Bwari, Abuja, FCT, 101 Law School Rd, 901101, Bwari',
    state_of_origin: 'Lagos State',
    lga: 'Ikeja',
  };
  const metaData = {
    ...templateDataClone.metadata,
    logo: {
      value: `${organisation.logoUrl}?b=${Date.now()}` || '',
      label: 'Logo',
      editable: true,
    },
    body: {
      value: templateDataClone?.metadata?.body?.value || '',
      label: 'Content',
      editable: true,
    },
    title: {
      value: templateData?.name || '',
      label: 'Title',
      editable: true,
    },
  };
  templateDataClone = {
    ...templateData,
    keys: templateTags,
    metadata: metaData,
  };
  return templateDataClone;
}
